import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

import withClickDrag from '../../../../../../hocs/withClickDrag';
import { FlexDiv } from '../../../../../base/Div';
import SubMenuWithDraggableOption from './SubMenuWithDraggableOption';

const defaultProps = {
    options: [],
};

const WrapperWithClickDrag = withClickDrag(FlexDiv, {});

const MenuWithDraggableOption = ({
    options, onClick, onDragEnd,
}) => (
    <WrapperWithClickDrag>
        <DragDropContext
            onDragEnd={onDragEnd}
        >
            <SubMenuWithDraggableOption
                options={options}
                onClick={onClick}
            />
        </DragDropContext>
    </WrapperWithClickDrag>
);


MenuWithDraggableOption.defaultProps = defaultProps;


export default MenuWithDraggableOption;
